import * as React from "react";
import type { SVGProps } from "react";
const SvgEighteenPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.455 5.638h.909v.91a.909.909 0 0 0 1.818 0v-.91h.909a.91.91 0 0 0 0-1.818h-.91v-.909a.909.909 0 0 0-1.817 0v.91h-.91a.91.91 0 0 0 0 1.817"
    />
    <path
      fill="currentColor"
      d="M20.727 9.274a.91.91 0 0 0-.709 1.073 8.18 8.18 0 0 1-9.2 9.744A8.182 8.182 0 0 1 4.802 8.116a8.18 8.18 0 0 1 8.853-4.132.927.927 0 0 0 .363-1.818A10 10 0 0 0 12 2.002a10 10 0 0 0-9.808 11.95 9.998 9.998 0 0 0 13.635 7.287A10 10 0 0 0 21.8 10.002a.91.91 0 0 0-1.073-.728"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.095 15.554a4.4 4.4 0 0 1-1.28-.167 2.6 2.6 0 0 1-.896-.463 2 2 0 0 1-.532-.69 2 2 0 0 1-.177-.846q0-.542.265-.955.276-.414.69-.64a1.6 1.6 0 0 1-.532-.562 1.7 1.7 0 0 1-.177-.797q0-.552.285-.995.286-.443.867-.709.58-.266 1.487-.266.897 0 1.477.266.582.255.857.7.286.442.286.994 0 .443-.177.797-.179.345-.512.572.432.216.699.64.266.423.266.965 0 .59-.325 1.083-.315.492-.956.788-.64.285-1.615.285m0-1.25q.315 0 .562-.109.255-.118.403-.315a.8.8 0 0 0 .148-.482.8.8 0 0 0-.148-.493.96.96 0 0 0-.403-.305 1.4 1.4 0 0 0-.562-.108q-.315 0-.571.108a.96.96 0 0 0-.404.305.8.8 0 0 0-.147.493q0 .275.147.482.148.197.404.315.255.108.571.109m0-3.004q.276 0 .502-.098a.95.95 0 0 0 .355-.276.7.7 0 0 0 .128-.414.7.7 0 0 0-.128-.413.77.77 0 0 0-.345-.276 1.3 1.3 0 0 0-.512-.098q-.284 0-.512.098a.84.84 0 0 0-.354.276.73.73 0 0 0-.119.413q0 .237.119.414.127.177.354.276.227.098.512.098"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M8.914 15.387a.26.26 0 0 0 .178.069h1.28a.23.23 0 0 0 .167-.07.23.23 0 0 0 .08-.176V8.809a.23.23 0 0 0-.08-.177.23.23 0 0 0-.167-.07H9.14a.4.4 0 0 0-.128.02.3.3 0 0 0-.109.05L6.64 10.384a.24.24 0 0 0-.118.168.28.28 0 0 0 .05.187l.58.758a.28.28 0 0 0 .158.108.22.22 0 0 0 .187-.049l1.35-1.034v4.688a.24.24 0 0 0 .068.177"
    />
  </svg>
);
export default SvgEighteenPlus;
